import React, { Component } from 'react';
import ReactTimeout from 'react-timeout'

import Notification from './Notification';

class NotificationContainer extends Component {
  constructor(props) {
      super(props);

      this.state = {
        notifications: [
          {
            type: 'info',
            title: 'Test Notification',
            detail: 'Just a test notification...',
            timeout: 5000
          }
        ]
      }
  }

  render() {
      return(
        <div className="notification-container">
            {
              this.state.notifications.map((x) => {
                <p> x.title </p>
              })
            }
        </div>
      );
  }
}

export default NotificationContainer;


// WEBPACK FOOTER //
// ./src/_components/notification/NotificationContainer.jsx